import {
  NewButton,
  NewButtonVariant,
  Tabs,
} from "@visiblethread/react-components";
import DocumentFileName from "components/DocumentFileName";
import Flex, { GAP_CLASS } from "components/Flex";
import { Maximize2, Minimize } from "lucide-react";
import { array, bool, func, number } from "prop-types";

import classes from "./CoverageDocumentTabs.module.scss";

const CoverageDocumentTabs = ({
  active,
  isTableExpanded,
  options = [],
  onSelect,
  onToggleTableExpanded,
}) => {
  const hasOneDocument = options?.length === 1;
  const TableSizeIcon = isTableExpanded ? Minimize : Maximize2;

  if (!options.length) return null;

  const expandButton = (
    <NewButton
      aria-label={
        isTableExpanded
          ? "Restore Outline Sections And Document Preview"
          : "Expand Requirements Table"
      }
      className={classes.expandBtn}
      leftIcon={<TableSizeIcon size={16} aria-hidden />}
      onClick={onToggleTableExpanded}
      variant={NewButtonVariant.l4}
    />
  );

  if (hasOneDocument) {
    return (
      <Flex
        className={classes.flex}
        data-testid="single-document-flex"
        gap={GAP_CLASS.GAP_200}
      >
        <DocumentFileName fileName={options[0].label} />
        {expandButton}
      </Flex>
    );
  }

  return (
    <Flex className={classes.flex} gap={GAP_CLASS.GAP_200}>
      <Tabs
        active={active}
        className={classes.tabs}
        elements={options.map((option) => ({
          content: <DocumentFileName fileName={option.label} />,
          onSelect: () => {
            onSelect(option);
          },
        }))}
      />
      {expandButton}
    </Flex>
  );
};

CoverageDocumentTabs.propTypes = {
  active: number,
  isTableExpanded: bool,
  options: array,
  onSelect: func,
  onToggleTableExpanded: func,
};

export default CoverageDocumentTabs;
